import { memo } from 'react';
import CIPasswordField, { type InputFieldProps } from '../../../components/fields/PasswordField';
import { PasswordContainer } from './shared';

const PasswordField = (props: InputFieldProps) => (
    <PasswordContainer>
        <CIPasswordField {...props} />
    </PasswordContainer>
);

export default memo(PasswordField);
